import { createAsyncThunk } from '@reduxjs/toolkit';
import deliveryService from '../../../api/services/delivery';

export const getDashboardData = createAsyncThunk('delivery/get-dashboard-data', async requestData => {
  return await deliveryService.getDashboardData(requestData);
});

export const createDelivery = createAsyncThunk('delivery/create-delivery', async requestData => {
  let formData = new FormData();

  formData.append('fullName', requestData.fullName);
  formData.append('paymentStatus', requestData.paymentStatus);
  formData.append('deliveryType', requestData.deliveryType);
  formData.append('phone', requestData.phone);
  formData.append('addressDetails', requestData.addressDetails);
  formData.append('locationLat', requestData.locationLat);
  formData.append('locationLng', requestData.locationLng);
  formData.append('locationName', requestData.locationName);

  if (requestData.ygiiOrderId) {
    formData.append('ygiiOrderId', requestData.ygiiOrderId);
  }
  if (requestData.ygiiPartnerId) {
    formData.append('ygiiPartnerId', requestData.ygiiPartnerId);
  }
  if (requestData.items.length) {
    for (var i = 0; i < requestData.items.length; i++) {
      formData.append(
        'items[]',
        JSON.stringify({
          name: requestData.items[i].name,
          quantity: requestData.items[i].quantity,
          price: requestData.items[i].price,
        }),
      );
      formData.append('files', requestData.items[i].photo);
    }
  }

  return await deliveryService.createDelivery(formData);
});

export const fetchDeliveries = createAsyncThunk('delivery/fetchDeliveries', async page => {
  return await deliveryService.fetchDeliveries(page);
});

export const fetchDelivery = createAsyncThunk('delivery/fetchOrder', async id => {
  return await deliveryService.fetchDelivery(id);
});
